module.exports = __webpack_public_path__ + "static/media/logo.efe517d4.png";